export default __webpack_public_path__ + "static/media/BESwifty_background.78356e03.jpg";